import {
  setLoadingConfigObject,
  shimmerPlaceholderConfig,
} from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils'

import style from './StoreCard.LoadingConfig.styles'

const loadingConfig = theme => [
  {
    main: setLoadingConfigObject('line', 4, null, style.storeDetails),
  },
  {
    style: style.seperator(theme),
  },
  {
    style: { marginTop: 20 },
    main: setLoadingConfigObject('square', 2, null, style.button),
  },
]

const calendarLoadingConfig = [
  {
    main: setLoadingConfigObject('line', 2, null, style.storeDetails),
  },
]


export { loadingConfig, shimmerPlaceholderConfig, calendarLoadingConfig }
